import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'

import initBugsnag from '@/helpers/initBugsnag'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)
const bugsnagVue = initBugsnag('Lifestyle Web - Alerts')

app.use(pinia)
app.use(bugsnagVue)
app.mount('#alerts-page')
